import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ArrowLeftBold, ArrowRightBold } from "@element-plus/icons";
import Card from "@/components/Answer/index.vue"; //答题组件

import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  components: {
    Head: Head,
    ArrowLeftBold: ArrowLeftBold,
    ArrowRightBold: ArrowRightBold,
    Card: Card
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var id = route.query.id;
    var state = route.query.state;
    var router = useRouter();
    var recordId = route.query.recordId; // 获取个人资料

    var Data = reactive({
      detail: [],
      isCard: false,
      recordId: 0,
      state: 0
    });

    function getQuestion() {
      return _getQuestion.apply(this, arguments);
    }

    function _getQuestion() {
      _getQuestion = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data, _yield$globalProperti3, _data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.recordId = recordId;
                Data.state = state;

                if (!(Data.state == 1)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAnswer"]({
                  recordId: Data.recordId
                });

              case 5:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                Data.detail.push(data);
                Data.isCard = true;
                _context2.next = 17;
                break;

              case 11:
                _context2.next = 13;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getQuestion"]({
                  paperId: id
                });

              case 13:
                _yield$globalProperti3 = _context2.sent;
                _data = _yield$globalProperti3.data;
                Data.detail.push(_data);
                Data.isCard = true;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getQuestion.apply(this, arguments);
    }

    var getCardChildren = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var _yield$globalProperti, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["submitQuestion"](item);

              case 2:
                _yield$globalProperti = _context.sent;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  ElMessage.success("已成功提交问卷");
                  changeInfoTotal(Number(id), "\u8C03\u67E5\u95EE\u5377", 19);
                  setTimeout(function () {
                    router.back();
                  }, 300);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCardChildren(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    onMounted(function () {
      // 详情
      getQuestion();
    });
    return {
      Data: Data,
      getCardChildren: getCardChildren
    };
  }
});